import React                      from 'react'
import { Observer }               from 'mobx-react'
import moment                     from 'moment'
import { DatePicker
       , Input }                  from 'antd'

import { TEXT }                   from '../00_assets'
import { kde_api_client_t }       from '../02_api'
import { address_form_fields
       , contact_form_fields
       , AddressEditor
       , ContactEditor
       , FIELD_TYPE
       , IFormEditor
       , IFormEditorModel
       , FormField
       , FormError
       , form_model
       , VALID }                  from '../10_ui'


export function create_client_editor_model ( client: kde_api_client_t )
{
  const fields =
    { name     : { label: TEXT.UI_NAME
                 , init: client.name || ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 , args: { autoFocus: true }
                 }
    , surnames : { label: TEXT.CLIENT_SURNAMES
                 , init: client.surnames || ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: ( ) => 0
                 }
    , notes    : { label: TEXT.CLIENT_NOTES
                 , init: client.notes || ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: ( ) => 0
                 }
    , birthday : { label: TEXT.CLIENT_BIRTHDAY
                 , init: client.birthday? moment( client.birthday ) : null // || moment( )
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: ( ) => 0
                 }
    , ...address_form_fields( client.address )
    , ...contact_form_fields( client.contact )
    } ;

  return form_model( fields
                   , ( data: IFormEditorModel ) =>
                      ({ name: data.name.value( )
                       , surnames: data.surnames.value( )
                       , notes: data.notes.value( )
                       , birthday: data.birthday.value( )? data.birthday.value( ).toISOString( ) : null
                       , address: data.address.value( )
                       , contact: data.contact.value( )
                       })
                   ) ;
}


export const ClientEditor: React.FC< { form: IFormEditor } > = ( { form } ) =>
<Observer render={ ( ) => 
   <div>
      <FormField field={ form.model.name     } />
      <FormField field={ form.model.surnames } />

      <FormField field={ form.model.birthday }>
        <DatePicker
          className="w-100"
          { ...form.model.birthday.bind( ) } />
      </FormField>

      <FormField field={ form.model.notes }>
        <Input.TextArea
          className="w-100"
          { ...form.model.notes.bind( ) } />
      </FormField>
      <ContactEditor form={ form } />
      <AddressEditor form={ form } />

      <FormError has={ form.show_error( ) } />
    </div>
} /> ;
